export const BLESS_API_BASE_URL = "https://api.bless.net";
export const BLESS_API_TEST_BASE_URL = "https://api.test.bless.net";
